import { Button } from "@/components/Button";
import { ReactNode } from "react";

interface ContactCardProps {
  icon: ReactNode;
  title: string;
  text: string;
  buttonText: string;
  buttonIcon?: ReactNode;
  link?: string;
  onClick?: () => void;
}

export const ContactCard = ({
  icon,
  title,
  text,
  buttonText,
  buttonIcon,
  link,
  onClick,
}: ContactCardProps) => {
  return (
    <div className="w-64 h-60 rounded-3xl bg-[#2f2f38] flex flex-col items-center justify-center gap-2 px-6 flex-shrink-0">
      {icon}
      <p className="text-business-green font-medium text-lg lg:text-xl text-center">
        {title}
      </p>
      <div>
        <p className="text-white font-light text-center text-[10px] lg:text-xs leading-none">
          {text}
        </p>
      </div>
      <Button
        size="sm"
        iconLeft
        block
        icon={buttonIcon}
        link={link}
        onClick={onClick}
        className="text-white !rounded-xl !bg-business-green !border-none !text-sm !font-medium !gap-2 mt-4 h-10"
      >
        {buttonText}
      </Button>
    </div>
  );
};
